import React, { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { getMetadata } from 'pages/Cms/helper'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { EventIcon } from 'redesign/components/atoms/Icon'
import { ICON_SIZE } from 'redesign/components/atoms/Icon/constants'
import routes from 'services/RoutesProvider/routes'
import ContentCard from '../content-card'
import type { EventCardProps } from './types'
import { getEventDateText } from './utils'

const EventCard: React.FC<EventCardProps> = ({ event, date, showChevron = false, onClick }) => {
  const { t, language, locale } = useFavurTranslation()
  const { startDate, endDate } = event
  const metadata = useMemo(() => getMetadata({ content: event, language }), [event, language])

  const subtitle = useMemo(
    () =>
      getEventDateText({
        event: event,
        startDate,
        endDate,
        locale,
        t,
      }),
    [endDate, event, locale, startDate, t],
  )
  const url = `${routes.cmsContentView}/${event.uuid}${date ? `?dateref=${date}` : ''}`

  if (!metadata) return null

  return (
    <ContentCard
      dataTestId="event-card"
      url={onClick ? undefined : url}
      header={{
        icon: <FramedIcon icon={EventIcon} size={ICON_SIZE.small} isFilled />,
        showChevron,
        title: metadata.title,
        subtitle,
      }}
      onClick={onClick}
    />
  )
}

export default EventCard
